import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_USER_JOBS = gql`
  query getUserJobs($filters: JobApplicationDetailFilter) {
    getUserJobs(filters: $filters) {
      count
      data {
        id
        title
        type
        noOfVacancies
        industry {
          id
          key
          value
        }
        salary {
          minimum
          maximum
          currency
        }
        workType
        minQualification
        preferredQualification
        about
        responsibilities
        location {
          city
          state
          country
        }
        application {
          isApplied
          status
        }
        applicationCount {
          totalApplied
          totalAccepted
        }
        createdBy {
          id
          name
          email
          profileImage
        }
        createdAt
      }
    }
  }
`;
